// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportFormatItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var CustomInput = require('share/components/controls/Izenda.CustomInput');
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');
  var m = require('mobx-react');
  var ReportDesignerWidget = require('share/components/hoc/Izenda.ReportDesignerWidget');
  var FormatStyleUtils = require('share/utils/Izenda.FormatStyleUtils');

  var CONSTANTS = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var ITEMS_TYPE = CONSTANTS.ITEMS_TYPE;
  var localizer = require('share/localization/Izenda.Localizer');
  const { find, startsWith, replace } = require('lodash/fp');

  var FormatItem = m.observer(function(props) {
    var store = props.store;
    var model = store.model;
    var formatGroup = props.formatElement;
    var listItems = formatGroup.formatItems;
    var viewMode = props.viewMode;

    var item = props.itemData || {};
    var itemSelected = item.isSelected;
    var classes = classnames(item.type, {
      'selected-item': itemSelected && !viewMode
    });
    var draggableBoxClass = classnames('format-item', {
      draggableBox: !viewMode
    });

    var cloneItem = updateImageUrl(item);
    var style = viewMode ? FormatStyleUtils.getStyle(cloneItem) : {};
    var backgroundStyle = FormatStyleUtils.getBackgroundStyle(item);
    var lineStyle = FormatStyleUtils.getLineStyle(item, viewMode);

    return (
      <div onMouseDown={selectWidget} className={draggableBoxClass} draggable="true">
        <div className={classes} style={style}>
          {renderItem()}
        </div>
        {viewMode ? null : (
          <a className={classes}>
            <span onClick={removeItem} className="icon-cancel" />
          </a>
        )}
      </div>
    );

    /**
     * update item for relative path
     */
    function updateImageUrl(item) {
      let result = {
        font: item.font,
        alignment: item.alignment,
        imageUrl: item.imageUrl
      };
      if (item.type === 'image') {
        let imageUrl = result.imageUrl;
        if (imageUrl && imageUrl.indexOf('\\\\') >= 0) {
          result.imageUrl = '';
        } else if (!startsWith('http', imageUrl)) {
          const origin = window.location.origin;
          // Replace \ by /
          imageUrl = replace(/\\/g, '/', imageUrl);
          const relativeUrl = startsWith('/', imageUrl) ? imageUrl : `/${imageUrl}`;
          result.imageUrl = `${origin}${relativeUrl}`;
        }
      }
      return result;
    }

    /**
     * update selected item when user click to one.
     */
    function selectWidget() {
      var onSelectingWidget = props.onClick;

      return (
        onSelectingWidget &&
        onSelectingWidget(props).then(function(valid) {
          valid && model.updateFormatItem && model.updateFormatItem(item, formatGroup.name);
        })
      );
    }

    /**
     * Render format items base on it's type
     * @returns {*}
     */
    function renderItem() {
      var nameVals = {
        presence: {
          presence: true,
          message: localizer.getText('REPORTDESIGNER_MESSAGE_ITEM_NAME_REQUIRED')
        }
      };

      var onValidate = function(newName) {
        var isExisting =
          formatGroup && formatGroup.checkExistingFormatItemName && formatGroup.checkExistingFormatItemName(newName);
        var selectedFormatGroup = formatGroup.name;

        if (isExisting) {
          var formatGroups =
            find(
              function(item) {
                return item.value === selectedFormatGroup;
              }.bind(this),
              CONSTANTS.FORMAT_GROUP
            ) || {};
          var formatGroupName = formatGroups.label;

          var message = String.format(CONSTANTS.MESSAGES.M01, formatGroupName);

          props.validationManager.updateErrors([
            {
              key: item.id,
              messages: [message]
            }
          ]);
        }

        return isExisting;
      };

      // Replace system variables
      var displayValue = item.value;
      if (props.replaceSystemVariable) {
        displayValue = props.replaceSystemVariable(store, item);
      }

      switch (item.type) {
        case ITEMS_TYPE.image.value:
          return viewMode ? (
            <div className="image u_block full-height" />
          ) : (
            <div className="image">
              <span className="icon-img" />
              <span>{item.name}</span>
            </div>
          );
        case ITEMS_TYPE.text.value:
        case ITEMS_TYPE.dateTime.value:
          return viewMode ? (
            <span style={backgroundStyle}>{displayValue}</span>
          ) : (
            <CustomInput
              className="form-control"
              value={item.name}
              onChange={handleTextChanged}
              validations={nameVals}
              field={item.id}
              onValidate={onValidate.bind(this)}
            />
          );
        case ITEMS_TYPE.pageNumber.value:
          return viewMode ? (
            <span style={backgroundStyle} className="page-number" />
          ) : (
            <CustomInput
              className="form-control"
              value={item.name}
              onChange={handleTextChanged}
              validations={nameVals}
              field={item.id}
              onValidate={onValidate.bind(this)}
            />
          );
        case ITEMS_TYPE.horizontalRule.value:
          return <div className="horizontal-rule" style={lineStyle} />;
        case ITEMS_TYPE.thinHorizontalRule.value:
          return <div className="thin-horizontal-rule" style={lineStyle} />;
        case ITEMS_TYPE.verticalRule.value:
          return <div className="vertical-rule" style={lineStyle} />;
      }
    }

    // handle change a format items' name when user edit it directly
    function handleTextChanged(value) {
      item.updateValueByKey('name', value.value);
    }

    // remove a format items when user click icon-cancel
    function removeItem() {
      listItems.splice(listItems.indexOf(item), 1);
      if (model.selectedFormatItem.id === item.id) {
        model.setSelectedFormatItem({});
      }
    }
  });

  FormatItem = ReportDesignerWidget.wrapper(FormatItem);

  module.exports = connect()(FormatItem);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.ReportFormatItem.jsx